function capitalizeFirst(value) {
  const text = String(value ?? '').trim()
  if (!text) {
    return ''
  }
  return text[0].toUpperCase() + text.slice(1)
}

export function mapModifierOption(raw) {
  return {
    id: String(raw?.id ?? ''),
    title: capitalizeFirst(raw?.title),
    priceDelta: Number(raw?.price_delta) || 0,
    isDefault: Boolean(raw?.is_default ?? raw?.isDefault),
  }
}

export function mapModifierGroup(raw) {
  const options = Array.isArray(raw?.options) ? raw.options.map(mapModifierOption) : []

  return {
    id: String(raw?.id ?? ''),
    title: String(raw?.title ?? ''),
    type: raw?.type === 'multiple' ? 'multiple' : 'single',
    required: Boolean(raw?.required),
    options: options.filter((option) => option.id && option.title),
  }
}
